import TableFilter from "./tableFilter";

function HubRequested() {
  return (
    <>
      <div className="content-wrapper">
        <div
          className="content-heading d-flex
                          justify-content-between"
        >
          <div>Payment Settings</div>
          <div>
           
          </div>
        </div>
        <TableFilter />
      </div>
    </>
  );
}

export default HubRequested;
